/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.WorldStreetsSettingsResource = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The WorldStreetsSettingsResource model module.
   * @module model/WorldStreetsSettingsResource
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>WorldStreetsSettingsResource</code>.
   * A class that represents the configuration settings for the World Streets service.
   * @alias module:model/WorldStreetsSettingsResource
   * @class
   * @param vectorTileDataSource {String} Defines where to get the vector tiles. Sqlite or loose files.
   * @param mbTileDatabaseFolder {String} The path to the folder containing the MBtiles SQLite database.
   * @param styleJsonFilePath {String} The path to the StyleJSON file which is used to style map tiles served by the World Streets raster endpoint.
   * @param vectorXyzTilesFolder {String} The path to the folder containing tiled vector map data in PBF format. Tiles should be gzipped and have the .pbf extension.
   * @param rasterXyzTilesToBeOptimizedFolder {String} The path to the folder where new raster map tile images will be written and held until they are processed by the palette optimizer.
   * @param rasterXyzTileCacheFolder {String} The path to the folder containing the active cache of palette-optimized PNG raster map tile images.
   * @param tileResponseCacheDurationInSeconds {String} Defines how long browsers should be allowed to locally cache map tiles.
   * @param sqliteTileCacheConnectionString {String} The ConnectionString for the sqlite database to cache the tiles.
   * @param rasterTileCacheType {String} Cache raster Tiles locally (local), sqlite.
   */
  var exports = function(vectorTileDataSource, mbTileDatabaseFolder, styleJsonFilePath, vectorXyzTilesFolder, rasterXyzTilesToBeOptimizedFolder, rasterXyzTileCacheFolder, tileResponseCacheDurationInSeconds, sqliteTileCacheConnectionString, rasterTileCacheType) {
    var _this = this;

    _this['vectorTileDataSource'] = vectorTileDataSource;
    _this['mbTileDatabaseFolder'] = mbTileDatabaseFolder;
    _this['styleJsonFilePath'] = styleJsonFilePath;
    _this['vectorXyzTilesFolder'] = vectorXyzTilesFolder;
    _this['rasterXyzTilesToBeOptimizedFolder'] = rasterXyzTilesToBeOptimizedFolder;
    _this['rasterXyzTileCacheFolder'] = rasterXyzTileCacheFolder;
    _this['tileResponseCacheDurationInSeconds'] = tileResponseCacheDurationInSeconds;
    _this['sqliteTileCacheConnectionString'] = sqliteTileCacheConnectionString;
    _this['rasterTileCacheType'] = rasterTileCacheType;
  };

  /**
   * Constructs a <code>WorldStreetsSettingsResource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WorldStreetsSettingsResource} obj Optional instance to populate.
   * @return {module:model/WorldStreetsSettingsResource} The populated <code>WorldStreetsSettingsResource</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('vectorTileDataSource')) {
        obj['vectorTileDataSource'] = ApiClient.convertToType(data['vectorTileDataSource'], 'String');
      }
      if (data.hasOwnProperty('mbTileDatabaseFolder')) {
        obj['mbTileDatabaseFolder'] = ApiClient.convertToType(data['mbTileDatabaseFolder'], 'String');
      }
      if (data.hasOwnProperty('styleJsonFilePath')) {
        obj['styleJsonFilePath'] = ApiClient.convertToType(data['styleJsonFilePath'], 'String');
      }
      if (data.hasOwnProperty('vectorXyzTilesFolder')) {
        obj['vectorXyzTilesFolder'] = ApiClient.convertToType(data['vectorXyzTilesFolder'], 'String');
      }
      if (data.hasOwnProperty('rasterXyzTilesToBeOptimizedFolder')) {
        obj['rasterXyzTilesToBeOptimizedFolder'] = ApiClient.convertToType(data['rasterXyzTilesToBeOptimizedFolder'], 'String');
      }
      if (data.hasOwnProperty('rasterXyzTileCacheFolder')) {
        obj['rasterXyzTileCacheFolder'] = ApiClient.convertToType(data['rasterXyzTileCacheFolder'], 'String');
      }
      if (data.hasOwnProperty('tileResponseCacheDurationInSeconds')) {
        obj['tileResponseCacheDurationInSeconds'] = ApiClient.convertToType(data['tileResponseCacheDurationInSeconds'], 'String');
      }
      if (data.hasOwnProperty('sqliteTileCacheConnectionString')) {
        obj['sqliteTileCacheConnectionString'] = ApiClient.convertToType(data['sqliteTileCacheConnectionString'], 'String');
      }
      if (data.hasOwnProperty('rasterTileCacheType')) {
        obj['rasterTileCacheType'] = ApiClient.convertToType(data['rasterTileCacheType'], 'String');
      }
    }
    return obj;
  }

  /**
   * Defines where to get the vector tiles. Sqlite or loose files.
   * @member {String} vectorTileDataSource
   */
  exports.prototype['vectorTileDataSource'] = undefined;
  /**
   * The path to the folder containing the MBtiles SQLite database.
   * @member {String} mbTileDatabaseFolder
   */
  exports.prototype['mbTileDatabaseFolder'] = undefined;
  /**
   * The path to the StyleJSON file which is used to style map tiles served by the World Streets raster endpoint.
   * @member {String} styleJsonFilePath
   */
  exports.prototype['styleJsonFilePath'] = undefined;
  /**
   * The path to the folder containing tiled vector map data in PBF format. Tiles should be gzipped and have the .pbf extension.
   * @member {String} vectorXyzTilesFolder
   */
  exports.prototype['vectorXyzTilesFolder'] = undefined;
  /**
   * The path to the folder where new raster map tile images will be written and held until they are processed by the palette optimizer.
   * @member {String} rasterXyzTilesToBeOptimizedFolder
   */
  exports.prototype['rasterXyzTilesToBeOptimizedFolder'] = undefined;
  /**
   * The path to the folder containing the active cache of palette-optimized PNG raster map tile images.
   * @member {String} rasterXyzTileCacheFolder
   */
  exports.prototype['rasterXyzTileCacheFolder'] = undefined;
  /**
   * Defines how long browsers should be allowed to locally cache map tiles.
   * @member {String} tileResponseCacheDurationInSeconds
   */
  exports.prototype['tileResponseCacheDurationInSeconds'] = undefined;
  /**
   * The ConnectionString for the sqlite database to cache the tiles.
   * @member {String} sqliteTileCacheConnectionString
   */
  exports.prototype['sqliteTileCacheConnectionString'] = undefined;
  /**
   * Cache raster Tiles locally (local), sqlite.
   * @member {String} rasterTileCacheType
   */
  exports.prototype['rasterTileCacheType'] = undefined;



  return exports;
}));



